import { FC } from "react";
import type { PrivacyTone } from "./privacyDisplay";

/**
 * The dotted track of variant A: dim dots, the fill up to the label's fixed
 * position (none for Unknown), the faint Mixed range, the scan while a check
 * runs and the knob. Decorative: the label next to it carries the meaning.
 * Its size and colours come from the surrounding `privacy-meter--<tone>`.
 */
export const PrivacyTrack: FC<{ tone: PrivacyTone; checking?: boolean }> = ({
  tone,
  checking = false,
}) => (
  <span className="privacy-meter__track" aria-hidden="true">
    <span className="privacy-meter__dots" />
    {tone === "mixed" && <span className="privacy-meter__range" />}
    {tone !== "unknown" && (
      <span className="privacy-meter__glow">
        <span className="privacy-meter__fill" />
      </span>
    )}
    {checking && <span className="privacy-meter__scan" />}
    <span className="privacy-meter__knob" />
  </span>
);
